var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_2876)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M14.25 8.90634L10.0938 4.7501L12.2951 2.54877C12.4064 2.4375 12.5574 2.375 12.7148 2.375C12.8722 2.375 13.0232 2.4375 13.1345 2.54877L16.4513 5.86338C16.5626 5.97471 16.6251 6.12568 16.6251 6.28308C16.6251 6.44049 16.5626 6.59145 16.4513 6.70279L14.25 8.90634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 16.0313H3.5625C3.40503 16.0313 3.25401 15.9688 3.14266 15.8574C3.03131 15.7461 2.96875 15.5951 2.96875 15.4376V12.1208C2.96882 11.9635 3.03128 11.8127 3.14242 11.7014L12.2951 2.54877C12.4064 2.4375 12.5574 2.375 12.7148 2.375C12.8722 2.375 13.0232 2.4375 13.1345 2.54877L16.4513 5.86338C16.5626 5.97472 16.6251 6.12568 16.6251 6.28308C16.6251 6.44049 16.5626 6.59145 16.4513 6.70279L7.125 16.0313Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 16.0312H7.125",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 4.75L14.25 8.90625",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_2876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.d7aaf840.svg";
export { ForwardRef as ReactComponent };